import React from "react";

interface BracketLane {
  count: number;
  top: number;
  step: number;
  itemHeight: number;
  gap: number;
}

export interface BracketConnectorsProps {
  from: BracketLane;
  to: BracketLane;
  height: number;
  width?: number;
  strokeWidth?: number;
  direction?: "ltr" | "rtl";
}

export const BracketConnectors: React.FC<BracketConnectorsProps> = ({
  from,
  to,
  height,
  width = 56,
  strokeWidth = 2,
  direction = "ltr",
}) => {
  const midX = direction === "ltr" ? width * 0.55 : width * 0.45;
  const startX = direction === "ltr" ? 0 : width;
  const endX = direction === "ltr" ? width : 0;

  return (
    <svg
      width={width}
      height={height}
      className="text-gray-300 flex-shrink-0"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      aria-hidden="true"
    >
      {Array.from({ length: to.count }, (_, index) => {
        const idxA = index * 2;
        const idxB = idxA + 1;
        const sourceA = from.top + idxA * (from.itemHeight + from.gap) + from.itemHeight / 2;
        const sourceB = from.top + idxB * (from.itemHeight + from.gap) + from.itemHeight / 2;
        const target = to.top + index * (to.itemHeight + to.gap) + to.itemHeight / 2;

        return (
          <g key={`connector-${index}`}>
            <path d={`M${startX} ${sourceA} H${midX}`} stroke="currentColor" strokeWidth={strokeWidth} />
            <path d={`M${startX} ${sourceB} H${midX}`} stroke="currentColor" strokeWidth={strokeWidth} />
            <path d={`M${midX} ${sourceA} V${sourceB}`} stroke="currentColor" strokeWidth={strokeWidth} />
            <path d={`M${midX} ${target} H${endX}`} stroke="currentColor" strokeWidth={strokeWidth} />
          </g>
        );
      })}
    </svg>
  );
};

/** Conector simple: línea horizontal desde un partido hacia la final central */
export interface FinalConnectorProps {
  fromY: number;
  toY: number;
  height: number;
  width?: number;
  strokeWidth?: number;
  direction?: "ltr" | "rtl";
}

export const FinalConnector: React.FC<FinalConnectorProps> = ({
  fromY,
  toY,
  height,
  width = 40,
  strokeWidth = 2,
  direction = "ltr",
}) => {
  const startX = direction === "ltr" ? 0 : width;
  const endX = direction === "ltr" ? width : 0;
  const midX = width / 2;

  return (
    <svg
      width={width}
      height={height}
      className="text-gray-300 flex-shrink-0"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      aria-hidden="true"
    >
      <path d={`M${startX} ${fromY} H${midX}`} stroke="currentColor" strokeWidth={strokeWidth} />
      <path d={`M${midX} ${fromY} V${toY}`} stroke="currentColor" strokeWidth={strokeWidth} />
      <path d={`M${midX} ${toY} H${endX}`} stroke="currentColor" strokeWidth={strokeWidth} />
    </svg>
  );
};
